<template>
  <div class="Index">
    <!-- pc -->
    <div class="PcWrap" v-if="loadMounted">
      <div :class="isscroll?'GuidePage scrolldown':'GuidePage scrollup'">
        <!-- 越极限 -->
        <div class="sloganBox">
          <img src="static/img/pc_logotext.png" class="textImg1" />
        </div>
        <!-- 文字 -->
        <div class="mainText">
          <span>中国 • 上海（香格里拉大酒店）</span>
          <span>&emsp;2021年4月18-20日</span>
        </div>
        <!-- 新增-视频链接 -->
        <a href="https://www.tunnelling.cn/PVideo/VideoMeetingPlay.aspx?videoId=3138" class="pc-imgBox" target="_blank">
          <img src="../assets/image/index-video-pic.png" />
          <div class="coverBox">
            <span></span>
          </div>
        </a>
        <!-- 下箭头 -->
        <span class="arrowBox" @click="NextScreenFn"></span>
      </div>
      <!-- 第二屏内容 -->
      <div :class="isscroll?'IndexContent scrolldown':'IndexContent scrollup'" @scroll="ScrollFn">
        <!-- 大会概况 -->
        <IndexSurvey :name="SurveyData.name" :content="SurveyData.content" :ispc="loadMounted" />
        <!-- 新闻中心 -->
        <IndexNewsCenter :center-info="NewsMenuInfo" :center-data="NewsData" />
        <!-- 主题演讲 -->
        <IndexKeynoteSpeech :ispc="loadMounted" />
        <!-- 现场花絮 -->
        <IndexLiveHighlights :ispc="loadMounted" />
        <!-- 大会议题 -->
        <IndexAgenda :daily-info="DailyInfo" :agenda-data="AgendaData.seminarNewsList" @AgendaInfoFn="AgendaInfoFn" ref="myAgenda" />
        <!-- 组织机构 -->
        <IndexOrganizated :organized-name="OrganizedData.name" :organized-data="OrganizedData.seminarSubTopics" />
        <!-- 特邀嘉宾 -->
        <IndexSpecialGuest :guest-href="GuestHref" :guest-data="SpecialGuestData.items" @GuestInfoFn="GuestInfoFn" ref="myGuest" />
        <!-- 底部信息 -->
        <Foot :issub="false" />
      </div>
    </div>
    <!-- mobile -->
    <div class="MobileWrap" v-else>
      <GuidePage v-show="showGuide" />
      <swiper id="swiper-container1" v-show="!showGuide" @slideChangeTransitionStart="SlideChangeFn" :options="swiperOptions">
        <swiper-slide>
          <div class="FirstScreen">
            <!-- logo -->
            <div class="logo">
              <img src="static/img/logo.png" />
            </div>
            <!-- 越极限 -->
            <div class="sloganBox">
              <img src="../assets/image/GuidePage_txt.png" />
            </div>
            <!-- banner -->
            <div class="bannerBox">
              <a href="https://www.tunnelling.cn/PVideo/VideoMeetingPlay.aspx?videoId=3138" class="imgBox">
                <img src="https://cits2021.tunnelling.cn/UploadFolderEx/20210422/20210422092405_1576.png" />
                <div class="coverBox">
                  <span></span>
                  <p>中国 • 上海（香格里拉大酒店）2021年4月18-20日</p>
                </div>
              </a>
            </div>
            <!-- 导航 -->
            <ul class="navbarBox">
              <li v-for="(item,index) in navList" :key="index">
                <router-link v-if="item.isrouter" :to="{ path: item.url, query:{ name: item.name, topicId: item.id } }">
                  <img :src="item.iconPath" />
                  <span>{{ item.name }}</span>
                </router-link>
                <a v-else :href="item.url">
                  <img :src="item.iconPath" />
                  <span>{{ item.name }}</span>
                </a>
              </li>
            </ul>
            <!-- 下箭头 -->
            <span class="arrowBox"></span>
          </div>
        </swiper-slide>
        <swiper-slide>
          <swiper id="swiper-container2" ref="swiperMobTwo" @sliderMove="SliderMoveFn" :options="swiperOptions2">
            <swiper-slide>
              <!-- 大会概况 -->
              <IndexSurvey :name="SurveyData.name" :content="SurveyData.content" :ispc="loadMounted" />
              <!-- 新闻中心 -->
              <IndexNewsCenter :center-info="NewsMenuInfo" :center-data="NewsData" />
              <!-- 主题演讲 -->
              <IndexKeynoteSpeech :ispc="loadMounted" />
              <!-- 现场花絮 -->
              <IndexLiveHighlights :ispc="loadMounted" />
              <!-- 大会议题 -->
              <IndexAgenda :daily-info="DailyInfo" :agenda-data="AgendaData.seminarNewsList" @AgendaInfoFn="AgendaInfoFn" ref="myAgenda" />
              <!-- 组织机构 -->
              <IndexOrganizated :organized-name="OrganizedData.name" :organized-data="OrganizedData.seminarSubTopics" />
              <!-- 特邀嘉宾 -->
              <IndexSpecialGuest :guest-href="GuestHref" :guest-data="SpecialGuestData.items" @GuestInfoFn="GuestInfoFn" :ispc="loadMounted" ref="myGuest" />
              <!-- 相关链接 -->
              <div class="AboutLinks">
                <a href="javascript:;" class="index-title">相关链接</a>
                <div class="content">
                  <a href="https://meetingchm.tunnelling.cn/" target="_blank" class="linksBox">
                    <div class="links_ImgBox"><img src="../assets/image/links.png" /></div>
                    <span>2018第二届</span>
                    <p class="Linebreak">中国城市基础设施建设与管理国际大会</p>
                  </a>
                  <a href="https://www.tunnelling.cn/PSpecial/ICIM.aspx" target="_blank" class="linksBox">
                    <div class="links_ImgBox"><img src="../assets/image/2016.png" /></div>
                    <span>2016</span>
                    <p class="Linebreak">中国城市基础设施建设与管理国际大会</p>
                  </a>
                </div>
              </div>
              <!-- 底部信息 -->
              <Foot />
            </swiper-slide>
          </swiper>
        </swiper-slide>
      </swiper>
    </div>
    <!-- logo+menu -->
    <div class="LogoMenuWrap" v-show="isFirstScreen">
      <div :class="isshowLogoMenu?'menuBox':'element'">
        <LogoMenu :issub="false" :pcsub="false" :loadmounted="loadMounted" />
      </div>
    </div>
    <!-- 特邀嘉宾弹窗 -->
    <div class="GuestCoverWrap" v-if="isShowGuestInfo">
      <div class="guest_coverbox">
        <div class="top_coverinfo">
          <img :src="GuestInfo.imagePath" />
          <div class="info">
            <h5>{{GuestInfo.name}}</h5>
            <p>{{GuestInfo.abstract}}</p>
            <div class="guest_intr" v-if="loadMounted" v-html="GuestInfo.content"></div>
          </div>
        </div>
        <span @click="CloseGuestInfoFn" v-if="loadMounted"></span>
        <div v-else class="cover_contentbox" v-html="GuestInfo.content"></div>
      </div>
      <span @click="CloseGuestInfoFn" v-if="!loadMounted"></span>
    </div>
    <!-- 大会议题弹窗 -->
    <div class="GuestCoverWrap agendaCoverWrap" v-if="isShowAgendaInfo">
      <div class="agenda_box">
        <h4>{{ agendaInfoTit }}</h4>
        <div class="agenda_cont_info" v-html="agendaInfo"></div>
        <span @click="CloseAgendaInfoFn" class="agenda_close" v-if="loadMounted"></span>
      </div>
      <span @click="CloseAgendaInfoFn" class="agenda_close" v-if="!loadMounted"></span>
    </div>
  </div>
</template>

<script>
  import GuidePage from '../components/GuidePage.vue'
  import LogoMenu from '../components/LogoMenu.vue'
  import IndexSurvey from '../components/IndexSurvey.vue'
  import IndexNewsCenter from '../components/IndexNewsCenter.vue'
  import IndexKeynoteSpeech from '../components/IndexKeynoteSpeech.vue'
  import IndexLiveHighlights from '../components/IndexLiveHighlights.vue'
  import IndexAgenda from '../components/IndexAgenda.vue'
  import IndexOrganizated from '../components/IndexOrganizated.vue'
  import IndexSpecialGuest from '../components/IndexSpecialGuest.vue'
  import Foot from '../components/Footer.vue'
  import { MenuNavListApi,SurveyApi,OrganizedApi,SpecialGuestApi,AgendaApi,NewsAllApi,AccessRecordsApi } from '../request/api.js'

  export default {
    name: 'Index',
    data() {
      return {
        isFirstScreen: true, // 首屏
        showGuide: true,  // 引导页
        navList: [
          {name: '大会概况', url: '/survey', iconPath: 'static/img/survey_icon.png', isrouter: true},
          {name: '新闻中心', url: '/newsCenter', iconPath: 'static/img/survey_icon.png', isrouter: true},
          {name: '主题演讲', url: '/keynoteSpeech', iconPath: 'static/img/wych_icon.png', isrouter: true},
          {name: '现场花絮', url: '/liveHighlights', iconPath: 'static/img/wycz_icon.png', isrouter: true},
          {name: '大会日程', url: '/agenda', iconPath: 'static/img/Agenda_icon.png', isrouter: true},
          {name: '特邀嘉宾', url: '/specialGuest', iconPath: 'static/img/SpecialGuest_icon.png', isrouter: true},
          {name: '组织机构', url: '/organized', iconPath: 'static/img/Organization_icon.png', isrouter: true},
          {name: '大会指南', url: '/guide', iconPath: 'static/img/guide_icon.png', isrouter: true},
          {name: '相关链接', url: 'https://www.tunnelling.cn/PSpecial/ICIM.aspx', iconPath: 'static/img/links_icon.png', isrouter: false}
        ], // 菜单
        SurveyData: {}, // 大会概况
        NewsData: [],  // 新闻中心
        NewsMenuInfo: {},  // 新闻中心菜单相关信息
        AgendaData: {}, // 大会议题
        agendaInfo: '',  // 大会议题具体内容
        agendaInfoTit: '',  // 大会议题标题
        DailyInfo: {},  // 大会日程
        OrganizedData: {}, // 组织机构
        SpecialGuestData: {}, // 特邀嘉宾
        GuestInfo: {}, // 特邀嘉宾详细信息
        GuestHref: {},  // 嘉宾菜单信息
        isShowGuestInfo: false, // 特邀嘉宾弹窗
        isshowLogoMenu: true, // logo+menu显隐
        translate: 0, // 记录上一次滑动页面的translate值
        swiperOptions: {
          direction: 'vertical'
        },
        swiperOptions2: {
          direction: 'vertical',
          nested: true,
          slidesPerView: 'auto',
          freeMode: true
        },
        isover: false, // 大会议题动画是否已执行
        agendaDom: null, // 大会议题dom
        isShowAgendaInfo: false,  // 大会议题弹窗
        isguestover: false, // 特邀嘉宾动画是否已执行
        guestDom: null, // 特邀嘉宾dom
        loadMounted: true, // pc加载菜单
        scrollVal: 0, // pc滚动条的值
        isscroll: false, // pc控制一二屏的切换
        isremoveListener: false // pc是否移除了事件
      }
    },
    created() {
      // 判断加载哪个dom
      let wid = window.innerWidth;
      if (wid >= 320 && wid <= 1024) {
        this.isFirstScreen = false;
        this.loadMounted = false;
        if(sessionStorage.getItem('loadGuide')){
          this.showGuide = false;
        }else{
          setTimeout(()=>{
            this.showGuide = false;
            sessionStorage.setItem('loadGuide','yes');
          },2500);
        }
      } else {
        this.loadMounted = true;
        //监听鼠标滚轮事件
        if (document.addEventListener) {
          document.addEventListener('DOMMouseScroll', this.handleScroll, false);
        } // firefox
        window.onmousewheel = document.onmousewheel = this.handleScroll; //IE/Opera/Chrome
      }

      this.GetPageDataFn();
    },
    mounted() {
      this.agendaDom = this.$refs.myAgenda.$el;
      this.guestDom = this.$refs.myGuest.$el;
      // 访客记录
      this.AccessRecordsFn();
    },
    computed: {
      // 移动端第二屏swiper
      swiper() {
        return this.$refs.swiperMobTwo.$swiper
      }
    },
    beforeDestroy(){
      document.removeEventListener("DOMMouseScroll", this.handleScroll, false); // firefox
      window.onmousewheel = document.onmousewheel = null; //IE/Opera/Chrome
    },
    methods: {
      // 访问记录
      AccessRecordsFn() {
        AccessRecordsApi({
          seminarTopicId: null
        });
      },
      // 点击箭头 翻到下一屏
      NextScreenFn(){
        this.isremoveListener = false;
        if (this.isscroll) return;
        this.isFirstScreen = true;
        this.isscroll = true;
      },
      //判断滚轮方向，
      handleScroll(e) {
        let ee = e || window.event;
        let down = true; // 定义一个标志，当滚轮向下滚时，执行一些操作
        down = ee.wheelDelta ? ee.wheelDelta < 0 : ee.detail > 0;
        if (down) {
          this.isremoveListener = false;
          if (this.isscroll) return;
          this.isFirstScreen = true;
          this.isscroll = true;
          return;
        } else {
          if (!this.isscroll) return;
          this.isFirstScreen = true;
          this.isscroll = false;
        }
      },
      // 获取页面数据
      GetPageDataFn() {
        // 获取菜单
        MenuNavListApi({
          IsRecommend: true,
          PageSize: 10,
          PageNumber: 1,
          Sorting: 'displayindex asc,creationdate asc'
        }).then(res => {
          for(let i = 0;i < res.items.length;i++){
            for(let j= 0;j < this.navList.length;j++){
              if(res.items[i].url == this.navList[j].url){
                this.$set(this.navList[j], 'id', res.items[i].id);
              }
            }

            // 新闻中心
            if(res.items[i].id == 11){
              this.GetNewsAllFn(res.items[i].id);
              this.NewsMenuInfo = res.items[i];
            }
            // 特邀嘉宾
            if(res.items[i].id == 6){
              this.GuestHref = res.items[i];
            }
            // 大会日程
            if(res.items[i].id == 7){
              this.DailyInfo = res.items[i];
            }
          }
        });
        // 大会概况
        SurveyApi({
          PageSize: 1,
          PageNumber: 1
        }).then(res => {
          this.SurveyData = res.items[0];
        });
        // 大会议题
        AgendaApi().then(res => {
          this.AgendaData = res.seminarSubTopics[0];
        });
        // 组织机构
        OrganizedApi({
          Sorting: 'displayindex asc',
          ChildrenSorting: 'displayindex asc'
        }).then(res => {
          this.OrganizedData = res;
        });
        // 特邀嘉宾
        SpecialGuestApi({
          PageSize: this.loadMounted ? 10 : 9,
          PageNumber: 1,
          Sorting: 'displayindex desc,creationdate asc'
        }).then(res => {
          this.SpecialGuestData = res;
        });
      },
      // 获取全部新闻
      GetNewsAllFn(topicId){
        NewsAllApi({
          seminarTopicId: topicId,
          PageSize: 4,
          PageNumber: 1,
          Sorting: 'displayindex desc,revisabilityDate desc'
        }).then(res => {
          this.NewsData = res.items;
        });
      },
      // pc滚动事件
      ScrollFn() {
        if (event.target.scrollTop == 0) {
          //监听鼠标滚轮事件
          if (document.addEventListener) {
            document.addEventListener('DOMMouseScroll', this.handleScroll, false);
          } // firefox
          window.onmousewheel = document.onmousewheel = this.handleScroll; //IE/Opera/Chrome
        }
        // 滚动滚动条移除事件
        if (this.isscroll && !this.isremoveListener) {
          this.isremoveListener = true;
          document.removeEventListener("DOMMouseScroll", this.handleScroll, false); // firefox
          window.onmousewheel = document.onmousewheel = null; //IE/Opera/Chrome
        }
        // 大会议题 动画
        if (!this.isover && event.target.scrollTop >= (this.agendaDom.offsetTop / 2) - 100) {
          this.isover = true;
          let agendaList = this.agendaDom.children[1].children;
          for (let i = 0; i < agendaList.length; i++) {
            setTimeout(() => {
              agendaList[i].classList.add('main_news_active');
            }, 100 * i);
          }
        }
        // 特邀嘉宾 动画
        if (!this.isguestover && event.target.scrollTop >= this.guestDom.offsetTop / 2) {
          this.isguestover = true;
          let guestList = this.guestDom.children[1].children;
          for (let i = 0; i < guestList.length; i++) {
            setTimeout(() => {
              guestList[i].classList.add('main_news_active');
            }, 100 * i);
          }
        }
        // 控制logo+menu显隐
        if (event.target.scrollTop > this.scrollVal) {
          this.scrollVal = event.target.scrollTop;
          if (!this.isshowLogoMenu) return;
          this.isshowLogoMenu = false;
        } else {
          this.scrollVal = event.target.scrollTop;
          if (this.isshowLogoMenu) return;
          this.isshowLogoMenu = true;
        }
      },
      // swiper从当前slide开始过渡到另一个slide时执行 控制第二屏logo+menu显隐
      SlideChangeFn() {
        this.isFirstScreen = !this.isFirstScreen;
      },
      // 第二屏滑动页面时 动xiao
      SliderMoveFn() {
        // 大会议题 动画
        if (!this.isover && Math.round(0 - this.swiper.translate) >= ((this.agendaDom.offsetTop - 736) / 2)) {
          this.isover = true;
          let agendaList = this.agendaDom.children[1].children;
          for (let i = 0; i < agendaList.length; i++) {
            setTimeout(() => {
              agendaList[i].classList.add('main_news_active');
            }, 100 * i);
          }
        }
        // 特邀嘉宾 动画
        if (!this.isguestover && Math.round(0 - this.swiper.translate) >= (this.guestDom.offsetTop / 2)) {
          this.isguestover = true;
          let guestList = this.guestDom.children[1].children;
          for (let i = 0; i < guestList.length; i++) {
            setTimeout(() => {
              guestList[i].classList.add('main_news_active');
            }, 100 * i);
          }
        }
        // 控制logo+menu显隐
        if (Math.abs(this.swiper.translate) > this.translate) {
          this.translate = Math.abs(this.swiper.translate);
          if (!this.isshowLogoMenu) return;
          this.isshowLogoMenu = false;
        } else {
          this.translate = Math.abs(this.swiper.translate);
          if (this.isshowLogoMenu) return;
          this.isshowLogoMenu = true;
        }
      },
      // 大会议题弹窗
      AgendaInfoFn(i){
        this.agendaInfo = this.AgendaData.seminarNewsList[i].content;
        this.agendaInfoTit = this.AgendaData.seminarNewsList[i].name;
        this.isShowAgendaInfo = true;
        document.documentElement.style.overflowY = 'hidden'; //禁止底层div滚动
      },
      // 关闭大会议题弹窗
      CloseAgendaInfoFn() {
        this.isShowAgendaInfo = false;
        document.documentElement.style.overflowY = 'auto'; //取消禁止屏幕滚动
      },
      // 特邀嘉宾信息
      GuestInfoFn(ind) {
        this.GuestInfo = this.SpecialGuestData.items[ind];
        this.isShowGuestInfo = true;
        document.documentElement.style.overflowY = 'hidden'; //禁止底层div滚动
      },
      // 关闭特邀嘉宾信息弹窗
      CloseGuestInfoFn() {
        this.isShowGuestInfo = false;
        document.documentElement.style.overflowY = 'auto'; //取消禁止屏幕滚动
      }
    },
    components: {
      Foot,
      LogoMenu,
      GuidePage,
      IndexSurvey,
      IndexNewsCenter,
      IndexKeynoteSpeech,
      IndexLiveHighlights,
      IndexOrganizated,
      IndexAgenda,
      IndexSpecialGuest
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {

    .menuBox {
      max-height: 80px;
      /* overflow: auto; */
      transition: max-height .5s;
    }

    .element {
      max-height: 0;
      overflow: hidden;
      transition: max-height .5s;
    }

    .LogoMenuWrap {
      position: fixed;
      top: 0;
      left: 0;
      height: 80px;
      width: 100%;
      z-index: 11;
    }

    /* 首页 */
    .GuidePage,
    .IndexContent {
      position: relative;
      left: 0;
      top: 0;
      -webkit-transform: translate3d(0, 0, 0);
      -moz-transform: translate3d(0, 0, 0);
      -ms-transform: translate3d(0, 0, 0);
      -o-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      -webkit-backface-visibility: hidden;
      -moz-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transition: all 0.6s ease-in-out;
      -moz-transition: all 0.6s ease-in-out;
      -o-transition: all 0.6s ease-in-out;
      transition: all 0.6s ease-in-out;
    }

    .scrolldown {
      -webkit-transform: translateY(-100%);
      -moz-transform: translateY(-100%);
      -ms-transform: translateY(-100%);
      -o-transform: translateY(-100%);
      transform: translateY(-100%);
    }

    .scrollup {
      -webkit-transform: translateY(0%);
      -moz-transform: translateY(0%);
      -ms-transform: translateY(0%);
      -o-transform: translateY(0%);
      transform: translateY(0%);
    }

    .IndexContent {
      width: 100%;
      height: 100%;
      overflow: hidden;
      overflow-y: scroll;
    }

    .Index {
      width: 100%;
      background: url(../assets/image/pc_indexbg.png);
      background-size: 100% 100%;
      overflow: hidden;
      height: 100%;
      min-height: 100%;
    }

    .PcWrap{
      width: 100%;
      height: 100%;
    }

    /* 引导页-第一屏 */

    .GuidePage {
      width: 100%;
      min-height: 100%;
      overflow: hidden;
    }

    .sloganBox {
      width: 53%;
      margin: 21vh auto 2vh;
      text-align: center;
      background: url(../assets/image/pc_guideline.png) no-repeat;
      background-size: contain;
      text-align: center;
      overflow: hidden;
    }

    .sloganBox img {
      width: 80%;
      height: auto;
    }

    .mainText {
      overflow: hidden;
      margin: 0 auto;
      text-align: center;
      font-size: 24px;
      color: #FFFFFF;
    }

    .countdown-box,.signupbox{
      margin: 0 auto;
      color: #FFFFFF;
      width: 350px;
      text-align: center;
    }

    .countdown-box>p{
      font-size: 18px;
      margin: 56px 0 25px;
    }

    .countdown,.signupbox{
      display: flex;
      justify-content: space-between;
    }

    .countdown-item span{
      display: block;
      width: 80px;
      background-color: rgba(0,0,0,.2);
    }

    .countdown-item span:first-child{
      font-size: 30px;
      line-height: 50px;
      border-bottom: 1px solid rgba(255,255,255,.2);
    }

    .countdown-item span:last-child{
      font-size: 16px;
      line-height: 38px;
    }

    .signupbox{
      margin: 40px auto 0;
    }

    .signupbox a{
      display: block;
      color: #FFFFFF;
      font-size: 0px;
      text-align: center;
      width: 150px;
      height: 150px;
      background: url(../assets/image/diamond_bg.png) no-repeat;
    }

    .signupbox a span{
      display: block;
      margin-top: 15px;
      font-size: 18px;
    }

    .signupbox a img{
      margin-top: 37px;
    }

    /* 新增 视频video */
    .pc-imgBox{
      display: block;
      width: 53%;
      margin: 50px auto 0;
      height: 328px;
      position: relative;
    }

    .pc-imgBox img{
      width: 100%;
      height: auto;
      max-height: 100%;
      border-radius: 5px;
    }

    .coverBox {
      position: absolute;
      top: 0;
      left: 0;
      text-align: center;
      color: #FFFFFF;
      width: 100%;
      height: 100%;
      border-radius: 3px;
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, .3) 70%);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .coverBox>span {
      display: inline-block;
      width: .8rem;
      height: .8rem;
      background: url(../assets/image/play_icon.png) no-repeat center center;
      background-size: cover;
    }

    /* 下箭头 */
    .arrowBox {
      display: block;
      background: url(../assets/image/arrowBot_icon.png) no-repeat center center;
      background-size: cover;
      width: 60px;
      height: 46px;
      position: fixed;
      bottom: 20px;
      left: 50%;
      cursor: pointer;
    }

    /* 大会议题弹窗 */
    .agenda_box{
      /* width: 80%;
      height: 60%;
      background: #FFFFFF;
      color: #000000;
      border-radius: 5px;
      padding: .3rem;
      overflow: hidden;
      overflow-y: auto; */
      position: relative;
      width: 940px;
      background: url(../assets/image/tanchuang_bg.png) center no-repeat rgba(44,48,65,.9);
      height: 460px;
    }

    .agenda_box h4{
      color: #01ffff;
      font-size: 20px;
      padding-top: 60px;
      margin-bottom: 20px;
      width: 600px;
      margin: 0 auto;
    }

    .agenda_cont_info{
      width: 600px;
      margin: 10px auto 0;
      line-height: 30px;
      font-size: 16px;
      color: #FFFFFF;
    }

    .agenda_close{
      background: url(../assets/image/nav_hide.png) no-repeat center center;
      display: inline-block;
      width: 20px;
      height: 20px;
      position: absolute;
      top: 15px;
      right: 15px;
      cursor: pointer;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {

    .menuBox {
      max-height: 1rem;
      overflow: auto;
      transition: max-height .5s;
    }

    .element {
      max-height: 0;
      overflow: hidden;
      transition: max-height .5s;
    }

    .MobileWrap,.swiper-container {
      width: 100%;
      height: 100%;
    }

    #swiper-container2 .swiper-slide {
      height: auto;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      display: block;
    }

    .LogoMenuWrap {
      position: fixed;
      top: 0;
      left: 0;
      height: 1rem;
      z-index: 11;
    }

    /* 相关链接 */
    .AboutLinks .content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .AboutLinks a {
      display: block;
      text-align: center;
      width: 2.78rem;
      color: #FFFFFF;
      font-size: .28rem;
      line-height: .4rem;
    }

    .AboutLinks .links_ImgBox {
      width: 2.7rem;
      padding: .13rem .24rem;
      background: rgba(220, 220, 220, .8);
      border-radius: 3px;
      margin-bottom: .2rem;
    }

    .AboutLinks a img {
      height: 1.14rem;
      width: 100%;
    }

    /* 首页 */
    .Index {
      width: 100%;
      height: 100%;
      background: url(../assets/image/index_bg.jpg) no-repeat;
      background-size: 100% 100%;
      overflow: hidden;
    }

    /* logo */
    .logo {
      width: 90%;
      margin: 3vh auto 0;
    }

    /* 越极限 */
    .sloganBox {
      width: 80%;
      /* height: 1.55rem; */
      height: 10vh;
      overflow: hidden;
      margin: 6vh auto 0;
      text-align: center;
    }

    .sloganBox img,
    .logo img {
      width: 100%;
      height: auto;
    }

    /* banner */
    .bannerBox {
      width: 90%;
      /* height: 2.2rem; */
      height: 16vh;
      margin: 4vh auto 2vh;
    }

    .imgBox {
      display: block;
      position: relative;
      height: 2.2rem;
      width: 100%;
    }

    .imgBox>img {
      width: 100%;
      height: 100%;
      border-radius: 3px;
    }

    .coverBox {
      position: absolute;
      top: 0;
      left: 0;
      text-align: center;
      color: #FFFFFF;
      width: 100%;
      height: 100%;
      border-radius: 3px;
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, .3) 70%);
    }

    .coverBox>span {
      display: inline-block;
      width: .8rem;
      height: .8rem;
      background: url(../assets/image/play_icon.png) no-repeat center center;
      background-size: cover;
      margin: .5rem 0 .3rem;
    }

    .coverBox p {
      font-size: .28rem;
    }

    /* 倒计时 */
    .countdown-box{
      margin: 0 auto;
      color: #FFFFFF;
      width: 5.16rem;
      text-align: center;
    }

    .countdown-box>p{
      font-size: .24rem;
      margin-bottom: 1vh;
    }

    .countdown{
      display: flex;
      justify-content: space-between;
    }

    .countdown-item span{
      display: block;
      width: 1.18rem;
      background-color: rgba(0,0,0,.2);
    }

    .countdown-item span:first-child{
      font-size: .44rem;
      line-height: 6vh;
      border-bottom: 1px solid rgba(255,255,255,.2);
    }

    .countdown-item span:last-child{
      font-size: .24rem;
      line-height: 4vh;
    }

    /* 导航 */
    .navbarBox {
      width: 90%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0 auto;
    }

    .navbarBox li:first-child, .navbarBox li:nth-child(4){
      margin-bottom: 1vh;
    }

    .navbarBox li:nth-child(3) a{
      background-image: linear-gradient(240deg, #cd4e90 0%, #f38f3f 100%);
      background-color: transparent;
    }

    .navbarBox a {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      width: 2.1rem;
      /* height: 1.6rem; */
      height: 11vh;
      background-color: rgba(0, 0, 0, .3);
      border-radius: 3px;
      text-align: center;
    }

    .navbarBox a img {
      width: .6rem;
      height: .6rem;
    }

    .navbarBox a span {
      font-size: .26rem;
      letter-spacing: 2px;
      color: #ffffff;
    }

    /* 下箭头 */
    .arrowBox {
      display: block;
      background: url(../assets/image/arrowBot_icon.png) no-repeat center center;
      background-size: cover;
      width: .64rem;
      height: .46rem;
      position: fixed;
      bottom: 2%;
      left: 50%;
    }

    /* 大会议题弹窗 */
    .agenda_box{
      width: 80%;
      height: 60%;
      background: #FFFFFF;
      color: #000000;
      border-radius: 5px;
      padding: .3rem;
      overflow: hidden;
      overflow-y: auto;
    }

    .agenda_box h4{
      color: #1058bb;
      font-size: .32rem;
      margin-bottom: .2rem;
    }

    .agenda_cont_info{
      font-size: .28rem;
      line-height: .4rem;
    }

    .agendaCoverWrap>span{
      background: rgba(0,0,0,.6) url(../assets/image/close_icon.png) no-repeat center center;
      background-size: .3rem .3rem;
      display: inline-block;
      border-radius: 50%;
      width: .5rem;
      height: .5rem;
      position: fixed;
      top: 18%;
      right: .5rem;
    }
  }

  .textImg1 {
    animation: fadeInUp 2.5s ease-in-out;
    -moz-animation: fadeInUp 2.5s ease-in-out;
    /* Firefox */
    -webkit-animation: fadeInUp 2.5s ease-in-out;
    /* Safari 和 Chrome */
    -o-animation: fadeInUp 2.5s ease-in-out;
    /* Opera */
  }

  .textImg2 {
    animation: fadeInUp 3s ease-in-out;
    -moz-animation: fadeInUp 3s ease-in-out;
    /* Firefox */
    -webkit-animation: fadeInUp 3s ease-in-out;
    /* Safari 和 Chrome */
    -o-animation: fadeInUp 3s ease-in-out;
    /* Opera */
  }

  @-webkit-keyframes fadeInUp {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }

    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }

  @keyframes fadeInUp {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }

    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }

  .arrowBox {
    animation: fadeInUp_arrow 3s infinite;
    -moz-animation: fadeInUp_arrow 3s infinite;
    /* Firefox */
    -webkit-animation: fadeInUp_arrow 3s infinite;
    /* Safari 和 Chrome */
    -o-animation: fadeInUp_arrow 3s infinite;
    /* Opera */
  }

  @-webkit-keyframes fadeInUp_arrow {
    0% {
      -webkit-transform: translate(-50%, 5px);
      transform: translate(-50%, 5px);
    }

    50% {
      -webkit-transform: translate(-50%, -5px);
      transform: translate(-50%, -5px);
    }

    100% {
      -webkit-transform: translate(-50%, 5px);
      transform: translate(-50%, 5px);
    }
  }

  @keyframes fadeInUp_arrow {
    0% {
      -webkit-transform: translate(-50%, 5px);
      transform: translate(-50%, 5px);
    }

    50% {
      -webkit-transform: translate(-50%, -5px);
      transform: translate(-50%, -5px);
    }

    100% {
      -webkit-transform: translate(-50%, 5px);
      transform: translate(-50%, 5px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue